import { Controller } from "@hotwired/stimulus";
import Honeybadger from "@honeybadger-io/js";
import ahoy from "ahoy.js";

export default class extends Controller {
  static targets = [
    "waiting",
    "installed",
    "button",
    "blocked",
    "blockedMessage",
    "blockedLink",
  ];

  connect() {
    const pollInterval = parseInt(this.element.dataset.pollInterval) || 5000;
    const checkStatus = function (interval) {
      if (this.element.dataset.installed === "true") return;

      const fetchOpts = {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };

      this.currentTimeout = setTimeout(() => {
        fetch(this.element.dataset.checkStatusUrl, fetchOpts)
          .then((response) => {
            // A 403 means something blocks this user from the endpoint -- an
            // account that requires MFA, say. Polling again can't clear that,
            // so stop and tell them what to do instead of hammering the
            // endpoint until they leave the page.
            if (response.status === 403) {
              return response
                .json()
                .catch(() => ({}))
                .then((data) => ({ blocked: true, ...data }));
            }

            return response.ok
              ? response.json()
              : Promise.reject(new Error(response.statusText));
          })
          .then((data) => {
            if (data.blocked) {
              console.debug("Blocked; giving up.");
              this.displayBlocked(data);
            } else if (data.installed) {
              console.debug("Installed!");
              this.displayInstalled(data);
            } else {
              console.debug(`Still waiting interval=${pollInterval}`);
              checkStatus(pollInterval);
            }
          })
          .catch((error) => {
            Honeybadger.notify(error);
            console.error(
              `Unable to fetch install status: ${error.message}`,
              error,
            );
            checkStatus(10000);
          });
      }, interval);
    }.bind(this);

    console.debug(`Connecting interval=${pollInterval}`);
    checkStatus();
  }

  disconnect() {
    console.debug(`Disconnecting timeout=${this.currentTimeout}`);
    clearTimeout(this.currentTimeout);
  }

  displayInstalled(statusData) {
    this.element.dataset.installed = "true";
    this.installedTargets.forEach((element) =>
      element.classList.remove("d-none"),
    );
    this.waitingTargets.forEach((element) => element.classList.add("d-none"));
    this.buttonTarget.href = statusData.error_url;
    this.buttonTarget.textContent = "View error report";
    ahoy.track("Project install completed", statusData);
  }

  displayBlocked(statusData) {
    this.waitingTargets.forEach((element) => element.classList.add("d-none"));

    if (!this.hasBlockedTarget) return;

    if (statusData.error && this.hasBlockedMessageTarget) {
      this.blockedMessageTarget.textContent = statusData.error;
    }

    if (this.hasBlockedLinkTarget) {
      if (statusData.url) {
        this.blockedLinkTarget.href = statusData.url;
      } else {
        this.blockedLinkTarget.classList.add("d-none");
      }
    }

    this.blockedTarget.classList.remove("d-none");
  }
}
